import { createAction, handleActions } from "redux-actions";
// - Actions
export const getProfileRequest = createAction("GET_PROFILE_REQUEST");
export const getProfileSuccess = createAction("GET_PROFILE_SUCCESS");

export const failure = createAction("PROFILE_ACTION_FAILURE");

// - Initial State
export const initialState = {
  user: null,
  usering: false,

  error: null
};

// - Reducers
const reducer = handleActions(
  {
    [getProfileRequest]: state => ({
      ...state, usering: true
    }),
    [getProfileSuccess]: (state, { payload: { user } }) => ({
      ...state, user: user, usering: false
    }),

    [failure]: (state, action) => ({
      ...state,
      loading: false,
      contacting: false,
      error: action.error
    })
  },
  initialState
);

export default reducer;
